/**
 * @desc 角色视图分页
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  defs.appCenter.IPage<defs.appCenter.RoleViewResponseDto>
>;
export function request(
  params: API.appCenter.role.viewPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/role/view/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
